import { useMemo } from 'react';
import { mockCharacterSpellsCollectionApi, mockSpellsApi } from '@/api/mockApi/abilitiesApi';
import { mockAuthApi } from '@/api/mockApi/authApi';
import { mockBoardApi } from '@/api/mockApi/boardApi';
import { mockCharacterApi, mockCharactersGroupApi } from '@/api/mockApi/characterApi';
import { mockCombatTrackerApi } from '@/api/mockApi/combatTrackerApi';
import { mockNoteApi, mockTagApi } from '@/api/mockApi/notesApi';
import { mockRoomApi } from '@/api/mockApi/roomApi';
import { mockUserApi } from '@/api/mockApi/userApi';
import { characterSpellsCollectionApi, spellsApi } from '@/api/realApi/abilitiesApi';
import { authApi } from '@/api/realApi/authApi';
import { boardApi } from '@/api/realApi/boardApi';
import { characterApi, charactersGroupApi } from '@/api/realApi/characterApi';
import { combatTrackerApi } from '@/api/realApi/combatTrackerApi';
import { noteApi, tagApi } from '@/api/realApi/notesApi';
import { roomApi } from '@/api/realApi/roomApi';
import { userApi } from '@/api/realApi/userApi';
import { useApiContext } from '@/context/ApiContext';
export function createApiInstances(useMockApi) {
    const authApiInstance = useMockApi ? mockAuthApi : authApi;
    const boardApiInstance = useMockApi ? mockBoardApi : boardApi;
    const characterApiInstance = useMockApi ? mockCharacterApi : characterApi;
    const characterGroupsApiInstance = useMockApi ? mockCharactersGroupApi : charactersGroupApi;
    const combatTrackerApiInstance = useMockApi ? mockCombatTrackerApi : combatTrackerApi;
    const roomApiInstance = useMockApi ? mockRoomApi : roomApi;
    const userApiInstance = useMockApi ? mockUserApi : userApi;
    const spellsApiInstance = useMockApi ? mockSpellsApi : spellsApi;
    const characterSpellsCollectionApiInstance = useMockApi
        ? mockCharacterSpellsCollectionApi
        : characterSpellsCollectionApi;
    const noteApiInstance = useMockApi ? mockNoteApi : noteApi;
    const tagApiInstance = useMockApi ? mockTagApi : tagApi;
    return {
        authApiInstance,
        boardApiInstance,
        characterApiInstance,
        characterGroupsApiInstance,
        combatTrackerApiInstance,
        roomApiInstance,
        userApiInstance,
        spellsApiInstance,
        characterSpellsCollectionApiInstance,
        noteApiInstance,
        tagApiInstance,
    };
}
export function useApiInstance() {
    const { useMockApi } = useApiContext();
    return useMemo(() => createApiInstances(useMockApi), [useMockApi]);
}
